import React, { useState } from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { ContentBodyGenerarDocumentos } from '../../components/GenerarDocumentos/ContentBodyGenerarDocumentos'
import './GenerarDocumentos.css'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const GenerarDocumentos = () => {
    const [MenuLateralAux, setMenuLateralAux] = useState();


    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <>
            <div className='GenerarDocumentos'  >
                <div className='headerGenerarDocumentos'>
                    <HeaderHome
                        chageMenuLateralAux={chageMenuLateralAux}

                    />
                </div>
                <div className="bodyGenerarDocumentos">
                    <ContentBodyGenerarDocumentos
                        MenuLateralAux={MenuLateralAux}
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className='footerReservarServicio'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
